<template>
  <div class="top-bar">
    <div class="logo" />
    <div class="lang-and-search">
      <span :key="`lang-canvas-${isLangOpen}`" class="lang-canvas">
        <ul class="lang-menu" :class="{active: isLangOpen}">
          <li :class="{active: TranslateService.currentLocale === 'en'}" @click="onClickLangItem('en')"><a>ENG</a></li>
          <li :class="{active: TranslateService.currentLocale === 'tc'}" @click="onClickLangItem('tc')"><a>繁</a></li>
          <li :class="{active: TranslateService.currentLocale === 'sc'}" @click="onClickLangItem('sc')"><a>简</a></li>
        </ul>
        <div class="icon icon-lang" @click="onClickLangIcon" />
      </span>
      <span :key="`search-canvas-${isSearch}`" class="search-canvas">
        <template v-if="!get(selected, 'isSearch')">
          <div v-if="isSearch" class="search-input">
            <input ref="searchInput" v-model="searchText" :placeholder="$filters.translate('T_SEARCH')" @blur="onBlurInput" @keyup.enter="onClickSearch">
            <button class="search-button" @click="onClickSearch">
              <svg alt="" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-6 w-6"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" style="font-size: 16px;" /></svg>
            </button>
          </div>
          <div v-else class="icon icon-search" @click="onClickSearch" />
        </template>
        <template v-else>
          <div class="search-input">
            <input ref="searchInput" v-model="searchText" :placeholder="$filters.translate('T_SEARCH')" @blur="onBlurInput" @keyup.enter="onClickSearch">
            <button class="search-button" @click="onClickSearch">
              <svg alt="" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-6 w-6"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" style="font-size: 16px;" /></svg>
            </button>
          </div>
        </template>
      </span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import TranslateService from '@/services/TranslateService'

export default {
  props: [
    'selected'
  ],
  data () {
    return {
      get: _.get,
      isLangOpen: false,
      isSearch: false,
      searchText: this.selected.searchText,
      TranslateService
    }
  },
  methods: {
    onBlurInput () {
      if (_.isEmpty(this.searchText) && this.isSearch === true) {
        this.isSearch = false
      }
    },
    async onClickSearch () {
      if (!this.isSearch) {
        this.isSearch = true
        await this.$forceUpdate()
        this.$refs.searchInput && this.$refs.searchInput.focus()
      } else {
        const text = this.searchText
        // this.searchText = null
        this.isSearch = false
        if (!_.isEmpty(_.trim(text))) {
          this.$emit('search', text)
          _.set(this.selected, 'isSearch', true)
          _.set(this.selected, 'searchText', text)
        }
      }
    },
    onClickSearchClose () {
      this.$emit('close')
    },
    onClickLangIcon () {
      this.isLangOpen = !this.isLangOpen
    },
    onClickLangItem (locale) {
      TranslateService.setCurrentLocale(locale, true)
      this.isLangOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
.top-bar {
  padding: 47px;
  // border: 1px red solid;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .logo {
    width: 257px;
    height: 47px;
    background-image: url('@/assets/hkbu-logo.png');
  }
  .lang-and-search {
    display: flex;

    .icon {
      width: 34px;
      height: 34px;
      cursor: pointer;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      &.icon-lang {
        background-image: url('@/assets/icon-lang.png');
      }
      &.icon-search {
        background-image: url('@/assets/icon-search.png');
      }
    }

    .search-canvas{
      margin-left: 34px;
      display: flex;
      align-items: start;
    }
  }
  .lang-canvas {
    position: relative;
    // border: 1px yellow solid;

    .lang-menu {
      z-index: 4;
      // border: 1px red solid;
      position: absolute;
      right: -20px;
      top: 50px;
      display: flex;
      padding: 18px 27px;
      color: grey;
      box-shadow: 0px 0px 5px grey;
      background-color: white;
      border-radius: 4px;
      pointer-events: none;
      opacity: 0;
      transition: opacity 0.2s;
      >li {
        cursor: pointer;
        margin-left: 27px;
        &:first-child {
          margin-left: 0px;
        }

        &.active {
          color: #275cf2;
        }
      }
      &.active {
        pointer-events: all;
        opacity: 1;
      }
    }
  }

  .search-input {
    position: relative;
    input {
      border: none;
      background: #edf2f6;
      padding: 6px 35px 6px 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      border-radius: 50px;
      font-size: 18px;
    }
    .search-button {
      cursor: pointer;
      position: absolute;
      background-color: transparent;
      border: none;
      bottom: 5px;
      right: 10px;
      line-height: 0;

      svg {
        width: 18px;
        height: 18px;
        color: #545556;
      }
    }
  }
  .search-close-button {
    .cross-stand-alone {
      display: block;
      $size: 34px;
      $thickness: 1px;
      $color: white;
      margin: 0;
      padding: 0;
      border: 0;
      background: none;
      position: relative;
      width: $size;
      height: $size;

      &:before,
      &:after {
        content: '';
        position: absolute;
        top: ($size - $thickness) / 2;
        left: 0;
        right: 0;
        height: $thickness;
        background: $color;
        border-radius: $thickness;
      }

      &:before {
        transform: rotate(45deg);
      }

      &:after {
        transform: rotate(-45deg);
      }

      span {
        display: block;
      }
    }
  }

}

@media screen and (max-width: 1280px)
{
  .top-bar {
    padding: 32px 36px;
    .logo {
      width: 190px;
      height: 34px;
      background-size: cover;
    }
  }
}

@media screen and (max-width: 768px)
{
  .top-bar {
    margin-top: 38px;
    padding: 0px 25px;
    .logo {
      width: 124px;
      height: 22px;
      background-size: cover;
    }
    .lang-and-search {
      .icon {
        width: 25px;
        height: 25px;
      }
      .search-canvas{
        margin-left: 15px;
      }
    }
    .search-input {
      input {
        padding: 5px 30px 4px 15px;
        font-size: 14px;
      }
      .search-button {
        bottom: 5px;
        right: 4px;
        svg {
          width: 15px;
          height: 15px;
        }
      }
    }
  }

}
</style>
